import { init } from '@rematch/core';
import * as models from './models';

// Init store
const store = init({ models });

// Export store
export default store;
